import { filterableContentTemplate } from './template';
import { getParams } from './params.js';

/**
 * Display Pills of active filters in filters footer.
 * @param  {object}   block                the block.
 * @param  {object}   inputs               all of the filter inputs.
 * @param  {Function} getFilterableContent Fetch the content.
 */
export const setActiveFilters = (block, inputs, getFilterableContent) => {
	const contentContainer = block.querySelector('.em-filterable-content__listings');
	const filterFooter = block.querySelector('.em-filterable-content__footer');
	const activeContainer = block.querySelector('.em-filterable-content__active-filters');
	const clearFilterButton = block.querySelector('.em-filterable-content__clear-filters button');
	const checked = {};

	function addActiveFilter(name, el) {
		if (checked[name] !== undefined) {
			checked[name].push(el.value);
		} else {
			checked[name] = [el.value];
		}
	}

	// Loop through the inputs and get the set values.
	inputs.forEach((e) => {
		const tax = e.getAttribute('data');

		// If is checked set the tax parameters.
		if (e.checked) {
			addActiveFilter(tax, e);
		}

		if (e.classList.contains('filter-search') && e.value) {
			addActiveFilter('search', e);
		}
	});

	// Check if "checked" object has values.
	if (Object.keys(checked).length > 0) {
		// Show filter footer.
		filterFooter.style.display = 'flex';
		clearFilterButton.style.display = 'block';

		// Output the pills!
		let html = '';
		Object.keys(checked).forEach((k) => {
			const values = checked[k];
			values.forEach((value) => {
				let input = block.querySelector(`[name="${k}_${value}"]`);
				input = input || block.querySelector(`[name="${k}"]`);

				if (input) {
					const label = block.querySelector(`[for="${input.id}"]`);

					if (label) {
						html += `<button class="pill" tabindex="0" data="${k}_${value}">${label.innerHTML}</button>`;
					} else {
						html += `<button class="pill" tabindex="0" data="${input.name}">${input.value}</button>`;
					}
				}
			});
		});
		activeContainer.innerHTML = html;

		// Get all the pills and assign onclick event handlers.
		const activeFilters = activeContainer.querySelectorAll('.pill');
		activeFilters.forEach((pill) => {
			const togglePill = (e) => {
				const $this = e.target;
				const input = block.querySelector(`[name="${$this.getAttribute('data')}"]`);
				input.checked = false;
				if ($this.getAttribute('data') === 'search') {
					input.value = '';
				}

				$this.remove();

				if (activeFilters.length === 1) {
					clearFilterButton.style.display = 'none';
				}

				// Reset the active filters.
				setActiveFilters(block, inputs);

				// Fetch the content.
				getFilterableContent(contentContainer, getParams(block.id, true, 1), filterableContentTemplate);
			};

			pill.onclick = (e) => togglePill(e);
			pill.onkeyup = (e) => {
				e.preventDefault();
				if (e.code === 'Enter' || e.code === 'Space') {
					togglePill(e);
				}
			};
		});
	} else {
		// clear all buttons.
		activeContainer.innerHTML = '';

		// Hide clear button.
		clearFilterButton.style.display = 'none';

		// If "checked" object empty (no filters checked) hide the filter footer.
		filterFooter.style.display = 'none';
	}
};

/**
 * Clear All Filters.
 * @param  {[type]} block [description]
 * @return {[type]}       [description]
 */
export const clearFilters = (block, inputs, getFilterableContent) => {
	const contentContainer = block.querySelector('.em-filterable-content__listings');
	const clear = block.querySelector('.em-filterable-content__clear-filters button');
	const filterFooter = block.querySelector('.em-filterable-content__footer');
	const activeContainer = block.querySelector('.em-filterable-content__active-filters');

	// Onclick remove all filters and refetch the content.
	const handleClear = () => {
		// Hide the filter footer.
		filterFooter.style.display = 'none';
		clear.style.display = 'none';
		activeContainer.innerHTML = '';
		inputs.forEach((e) => {
			if (e.checked) {
				e.checked = false;
			} else if (e.getAttribute('name') === 'search') {
				e.value = '';
			}
		});

		// Fetch the content.
		getFilterableContent(contentContainer, getParams(block.id, true, 1), filterableContentTemplate);
	};

	clear.onclick = () => handleClear();
	clear.onkeyup = (e) => {
		e.preventDefault();
		if (e.code === 'Enter' || e.code === 'Space') {
			handleClear();
		}
	};
};
